<div class="row">
  <div class="col-md-12 col-xl-6">

    <div class="about-instance-title">
      <h1 i18n class="title">About {{ instanceName }}</h1>

      <a routerLink="/about/contact" i18n *ngIf="isContactFormEnabled" class="contact-admin">Contact us</a>
    </div>

    <div class="instance-badges" *ngIf="categories.length !== 0 || languages.length !== 0">
      <span *ngFor="let category of categories" class="badge badge-primary category">{{ category }}</span>

      <span *ngFor="let language of languages" class="badge badge-secondary language">{{ language }}</span>
    </div>

    <div class="short-description">
      <div class="block short-description">{{ shortDescription }}</div>

      <div i18n *ngIf="isNSFW" class="block dedicated-to-nsfw">This instance is dedicated to sensitive/NSFW content.</div>
    </div>

    <div class="anchor" id="administrators-and-sustainability"></div>
    <a
      *ngIf="html.administrator || html.maintenanceLifetime || html.businessModel"
      class="anchor-link"
      routerLink="/about/instance"
      fragment="administrators-and-sustainability"
      #anchorLink
      (click)="onClickCopyLink(anchorLink)"
    >
      <h2 i18n class="middle-title">
        ADMINISTRATORS & SUSTAINABILITY
      </h2>
    </a>

    <div class="block administrator" *ngIf="html.administrator">
      <div class="anchor" id="administrators"></div>
      <a
        class="anchor-link"
        routerLink="/about/instance"
        fragment="administrators"
        #anchorLink
        (click)="onClickCopyLink(anchorLink)">
        <h3 i18n class="section-title">Who we are</h3>
      </a>

      <div [innerHTML]="html.administrator"></div>
    </div>

    <div class="block creation-reason" *ngIf="html.creationReason">
      <div class="anchor" id="creation-reason"></div>
      <a
        class="anchor-link"
        routerLink="/about/instance"
        fragment="creation-reason"
        #anchorLink
        (click)="onClickCopyLink(anchorLink)">
        <h3 i18n class="section-title">Why we created this instance</h3>
      </a>

      <div [innerHTML]="html.creationReason"></div>
    </div>

    <div class="block maintenance-lifetime" *ngIf="html.maintenanceLifetime">
      <div class="anchor" id="maintenance-lifetime"></div>
      <a
        class="anchor-link"
        routerLink="/about/instance"
        fragment="maintenance-lifetime"
        #anchorLink
        (click)="onClickCopyLink(anchorLink)">
        <h3 i18n class="section-title">How long we plan to maintain this instance</h3>
      </a>

      <div [innerHTML]="html.maintenanceLifetime"></div>
    </div>

    <div class="block business-model" *ngIf="html.businessModel">
        <div class="anchor" id="business-model"></div>
        <a
          class="anchor-link"
          routerLink="/about/instance"
          fragment="business-model"
          #anchorLink
          (click)="onClickCopyLink(anchorLink)">
          <h3 i18n class="section-title">How we will pay for keeping our instance running</h3>
        </a>

      <div [innerHTML]="html.businessModel"></div>
    </div>

    <div class="anchor" id="information"></div>
    <a
      *ngIf="descriptionContent"
      class="anchor-link"
      routerLink="/about/instance"
      fragment="information"
      #anchorLink
      (click)="onClickCopyLink(anchorLink)">
      <h2 i18n class="middle-title">
        INFORMATION
      </h2>
    </a>

    <div class="block description">
      <div class="anchor" id="description"></div>
      <a
        class="anchor-link"
        routerLink="/about/instance"
        fragment="description"
        #anchorLink
        (click)="onClickCopyLink(anchorLink)">
        <h3 i18n class="section-title">Description</h3>
      </a>

      <my-custom-markup-container [content]="descriptionContent"></my-custom-markup-container>
    </div>

    <div myPluginSelector pluginSelectorId="about-instance-moderation">
      <div class="anchor" id="moderation"></div>
      <a
        *ngIf="html.moderationInformation || html.codeOfConduct || html.terms"
        class="anchor-link"
        routerLink="/about/instance"
        fragment="moderation"
        #anchorLink
        (click)="onClickCopyLink(anchorLink)">
        <h2 i18n class="middle-title">
          MODERATION
        </h2>
      </a>

      <div class="block moderation-information" *ngIf="html.moderationInformation">
        <div class="anchor" id="moderation-information"></div>
        <a
          class="anchor-link"
          routerLink="/about/instance"
          fragment="moderation-information"
          #anchorLink
          (click)="onClickCopyLink(anchorLink)">
          <h3 i18n class="section-title">Moderation information</h3>
        </a>

        <div [innerHTML]="html.moderationInformation"></div>
      </div>

      <div class="block code-of-conduct" *ngIf="html.codeOfConduct">
        <div class="anchor" id="code-of-conduct"></div>
        <a
          class="anchor-link"
          routerLink="/about/instance"
          fragment="code-of-conduct"
          #anchorLink
          (click)="onClickCopyLink(anchorLink)">
          <h3 i18n class="section-title">Code of conduct</h3>
        </a>

        <div [innerHTML]="html.codeOfConduct"></div>
      </div>

      <div class="block terms">
        <div class="anchor" id="terms"></div>
        <a
          class="anchor-link"
          routerLink="/about/instance"
          fragment="terms"
          #anchorLink
          (click)="onClickCopyLink(anchorLink)">
          <h3 i18n class="section-title">Terms</h3>
        </a>

        <div [innerHTML]="html.terms"></div>
      </div>
    </div>

    <div myPluginSelector pluginSelectorId="about-instance-other-information">
      <div class="anchor" id="other-information"></div>
      <a
        *ngIf="html.hardwareInformation"
        class="anchor-link"
        routerLink="/about/instance"
        fragment="other-information"
        #anchorLink
        (click)="onClickCopyLink(anchorLink)">
        <h2 i18n class="middle-title">
          OTHER INFORMATION
        </h2>
      </a>

      <div class="block hardware-information" *ngIf="html.hardwareInformation">
        <div class="anchor" id="hardware-information"></div>
        <a
          class="anchor-link"
          routerLink="/about/instance"
          fragment="hardware-information"
          #anchorLink
          (click)="onClickCopyLink(anchorLink)">
          <h3 i18n class="section-title">Hardware information</h3>
        </a>

        <div [innerHTML]="html.hardwareInformation"></div>
      </div>
    </div>
  </div>

  <div class="col-md-12 col-xl-6" myPluginSelector pluginSelectorId="about-instance-features">
    <h2 class="sr-only" i18n>FEATURES</h2>
    <my-instance-features-table></my-instance-features-table>
  </div>

  <div class="col" myPluginSelector pluginSelectorId="about-instance-statistics">
    <div class="anchor" id="statistics"></div>
    <a
      class="anchor-link"
      routerLink="/about/instance"
      fragment="statistics"
      #anchorLink
      (click)="onClickCopyLink(anchorLink)">
      <h2 i18n class="middle-title">STATISTICS</h2>
    </a>
    <my-instance-statistics></my-instance-statistics>
  </div>
</div>

<my-contact-admin-modal #contactAdminModal></my-contact-admin-modal>
